import React, { memo, useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const ViewPdf = ({
  file,
  pageNumber,
  scale = 1,
  onPdfLoadSuccess = () => {},
}) => {
  const [pageCount, setPageCount] = useState(null);
  const [currentPage, setCurrentPage] = useState(pageNumber || 1);

  useEffect(() => {
    setCurrentPage(pageNumber);
  }, [pageNumber]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setPageCount(numPages);
    onPdfLoadSuccess(numPages);
  };

  return (
    <Document
      file={{ url: file }}
      onLoadSuccess={onDocumentLoadSuccess}
      onLoadError={(error) => console.error("PDF Load Error", error)}
    >
      {pageCount && (
        <Page
          key={`page_${currentPage}`}
          pageNumber={currentPage}
          scale={scale}
        />
      )}
    </Document>
  );
};

export default memo(ViewPdf);
